import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/layout';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name: 'router-name'            the name is used by <keep-alive> (must set!!!)
* alwaysShow: false			 	 means page , not dropdown select
* meta : {
	title: 'title'               the name show in submenu and breadcrumb (recommend set)
	icon: 'svg-name'             the icon show in the sidebar
	open: false					 if true , the nav will be default opend
	cache: false                 if true , the page will be cached(default is false)
	pointTo: path				 point to whitch nav , fullpath with '/'
	role: 'pub_feed'             control the privilege, show or hide
  }
**/
export const constantRouterMap = [
    {
        path: '',
        component: Layout,
        redirect: 'homepage',
        meta: { icon: 'icon_nav_home' },
        children: [
            {
                path: 'homepage',
                component: () =>
                    import(/* webpackChunkName: "homepage" */ '@/views/homepage/index'),
                name: 'homepage',
                meta: { title: '首页' },
            },
        ],
    },
    {
        path: '/painting',
        component: Layout,
        redirect: 'noredirect',
        name: 'painting',
        meta: { title: '作品管理', icon: 'icon_nav_comic', open: true },
        children: [
            {
                path: '/contract',
                name: 'contract',
                component: () =>
                    import(/* webpackChunkName: "contract" */ '@/views/painting/index'),
                redirect: '/contract/topiclist',
                meta: { title: '签约作品', role: 'has_upload_privilege' },
                alwaysShow: true,
                children: [
                    {
                        path: 'topiclist',
                        component: () => import('@/views/painting/contract/index'),
                        name: 'contractTopicList',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: 'topic',
                        component: () => import('@/views/painting/contract/topic'),
                        name: 'contractNewTopic',
                        meta: { title: '新建作品' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/topic',
                        component: () => import('@/views/painting/contract/topic'),
                        name: 'contractEditTopic',
                        meta: { title: '编辑作品' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/comic',
                        component: () => import('@/views/painting/contract/comic'),
                        name: 'contractNewComic',
                        meta: { title: '新建章节' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/comic/:comicId',
                        component: () => import('@/views/painting/contract/comic'),
                        name: 'contractEditComic',
                        meta: { title: '编辑章节' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/comiclist',
                        component: () => import('@/views/painting/contract/comiclist'),
                        name: 'contractComicList',
                        meta: { title: '管理章节' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/success/:comicNum',
                        component: () => import('@/views/painting/contract/success'),
                        name: 'contractSuccess',
                        meta: { title: '提交成功' },
                        hidden: true,
                    },
                ],
            },
            {
                path: '/practice',
                name: 'practice',
                component: () => import('@/views/painting/index'),
                redirect: '/practice/topiclist',
                meta: { title: '投稿作品', role: 'have_intern_privilege' },
                alwaysShow: true,
                children: [
                    {
                        path: 'topiclist',
                        component: () => import('@/views/painting/practice/index'),
                        name: 'practiceTopicList',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: 'topic',
                        component: () => import('@/views/painting/practice/topic'),
                        name: 'practiceNewTopic',
                        meta: { title: '新建作品' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/topic',
                        component: () => import('@/views/painting/practice/topic'),
                        name: 'practiceEditTopic',
                        meta: { title: '编辑作品' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/comic',
                        component: () => import('@/views/painting/practice/comic'),
                        name: 'practiceNewComic',
                        meta: { title: '新建章节' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/comic/:comicId',
                        component: () => import('@/views/painting/practice/comic'),
                        name: 'practiceEditComic',
                        meta: { title: '编辑章节' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/comiclist',
                        component: () => import('@/views/painting/practice/comiclist'),
                        name: 'practiceComicList',
                        meta: { title: '管理章节' },
                        hidden: true,
                    },
                    {
                        path: ':topicId/success/:comicNum',
                        component: () => import('@/views/painting/practice/success'),
                        name: 'practiceSuccess',
                        meta: { title: '提交成功' },
                        hidden: true,
                    },
                ],
            },
            {
                path: '/material',
                name: 'material',
                component: () => import('@/views/painting/index'),
                redirect: '/material/cover',
                meta: { title: '素材文件' },
                alwaysShow: true,
                children: [
                    {
                        path: 'cover',
                        component: () => import('@/views/painting/material/coverIndex'),
                        name: 'cover',
                        meta: { title: '封面素材' },
                        hidden: true,
                    },
                    {
                        path: 'font',
                        component: () => import('@/views/painting/material/fontList'),
                        name: 'fontList',
                        meta: { title: '官方字体' },
                        hidden: true,
                    },
                ],
            },
        ],
    },
    {
        path: '/income',
        component: Layout,
        redirect: 'noredirect',
        name: 'income',
        meta: { title: '收益管理', icon: 'icon_nav_income', open: true },
        children: [
            {
                path: '/income/painting',
                name: 'paintingIncome',
                component: () => import('@/views/income/painting/index2'),
                meta: { title: '创作收益', role: 'comic_income', cache: true },
                alwaysShow: true,
                children: [
                    {
                        path: '/income/total',
                        component: () => import('@/views/income/painting/index2'),
                        name: 'incomeTotal',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/income/pay',
                        component: () => import('@/views/income/painting/index2'),
                        name: 'incomePay',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/income/card',
                        component: () => import('@/views/income/painting/index2'),
                        name: 'incomeCard',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/income/script',
                        component: () => import('@/views/income/painting/index2'),
                        name: 'incomeScript',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/income/vip',
                        component: () => import('@/views/income/painting/index2'),
                        name: 'incomeVip',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/income/ad',
                        component: () => import('@/views/income/painting/index2'),
                        name: 'incomeAd',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/income/reward',
                        component: () => import('@/views/income/painting/index2'),
                        name: 'incomeReward',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/income/other',
                        component: () => import('@/views/income/painting/index2'),
                        name: 'incomeOther',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/income/social',
                        component: () => import('@/views/income/painting/index2'),
                        name: 'incomeSocial',
                        meta: {},
                        hidden: true,
                    },
                ],
            },
            {
                path: '/income/comic/get',
                name: 'incomeComicGet',
                component: () => import('@/views/income/painting/get'),
                meta: { title: '创作收益提现', role: 'author_income' },
                alwaysShow: true,
                children: [
                    {
                        path: 'detail',
                        component: () => import('@/views/income/painting/detail'),
                        name: 'incomeComicGetDetail',
                        meta: { title: '提现' },
                        hidden: true,
                    },
                ],
            },
            // {
            // 	path: '/income/live',
            // 	name: 'incomeLive',
            // 	component: () => import('@/views/income/live/index'),
            // 	meta: { title: '直播收益', role: 'pub_live', cache: true },
            // 	alwaysShow: true,
            // 	children: [{
            // 		path: 'get',
            // 		component: () => import('@/views/income/live/get'),
            // 		name: 'incomeLiveGet',
            // 		meta: { title: '提现' },
            // 		hidden: true
            // 	}]
            // },
            // {
            // 	path: '/income/social/reward',
            // 	name: 'incomeSocial',
            // 	component: () => import('@/views/income/socialReward/index'),
            // 	meta: { title: '社区加料管理' },
            // 	alwaysShow: true,
            // 	children: [
            // 		{
            // 		path: 'get',
            // 		component: () => import('@/views/income/live/get'),
            // 		name: 'incomeLiveGet',
            // 		meta: { title: '提现' },
            // 		hidden: true
            // 	}]
            //   }
        ],
    },
    {
        path: '/excitation',
        component: Layout,
        redirect: 'noredirect',
        name: 'excitation',
        meta: { icon: 'icon_topic_exposure', title: '创作激励', open: true },
        children: [
            {
                path: 'flux_guide',
                name: 'fluxGuide',
                component: () => import('@/views/excitation/fluxGuide/index'),
                meta: {
                    title: '流量指南',
                    cache: false,
                    tips: 'new',
                    tipsStyle: 'font-weight:bold;font-size:12px;',
                    tipsDeadLine: 1681135200000,
                },
            },
            {
                path: 'interaction', // 读者交互介绍
                name: 'fluxInteraction',
                component: () => import('@/views/excitation/fluxGuide/interaction'),
                meta: {},
                hidden: true,
            },
            {
                path: 'labelList', // 作品标签介绍
                name: 'fluxLabelList',
                component: () => import('@/views/excitation/fluxGuide/labelList'),
                meta: {},
                hidden: true,
            },
            {
                path: 'newstar',
                name: 'newstar',
                component: () => import('@/views/incentive/newstar/index'),
                meta: { title: '新星力beta', role: 'motivation', cache: false },
            },
            {
                path: 'reward',
                name: 'excitationReward',
                component: () => import('@/views/excitation/reward/index'),
                meta: { title: '漫画加料', role: 'comic_reward_motivation', cache: false },
                hidden: false,
            },
            {
                path: '/contract_manage',
                name: '',
                component: () => import('@/views/excitation/contractManage/index'),
                redirect: '/contract_manage/list',
                meta: { title: '签约合同管理', role: 'author_contract', cache: false },
                alwaysShow: true,
                children: [
                    {
                        path: '/contract_manage/list',
                        component: () => import('@/views/excitation/contractManage/list'),
                        name: 'contractManage',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/contract_manage/edit',
                        component: () =>
                            import(
                                /* webpackChunkName: "contracteditForm" */ '@/views/excitation/contractManage/editForm'
                            ),
                        name: 'contracteditForm',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/contract_manage/confirm',
                        component: () => import('@/views/excitation/contractManage/confirm'),
                        name: 'contractconfirmForm',
                        meta: {},
                        hidden: true,
                    },
                ],
            },
            {
                path: 'comicCard',
                name: 'ComicCard',
                component: () => import('@/views/excitation/comicCard/index'),
                meta: { title: '漫画卡片', role: 'game_card', cache: false },
            },
            // {
            //   path: 'contribution',
            //   name: 'Contribution',
            //   component: () => import('@/views/excitation/contribution/index'),
            //   meta: { title: '投稿签约', role: 'submit_topic_sign', cache: false },
            // }
        ],
    },
    {
        path: '/dataanalysis',
        component: Layout,
        redirect: 'noredirect',
        name: 'dataanalysis',
        meta: { title: '数据分析', icon: 'icon_data_analysis', open: true },
        children: [
            {
                path: '/dataanalysis/opusview',
                name: 'opusviews',
                component: () => import('@/views/dataanalysis/opusview/index'),
                meta: { title: '漫画数据', role: 'comic_analysis', cache: true },
                alwaysShow: true,
                children: [
                    {
                        path: '/dataanalysis/opusview',
                        component: () => import('@/views/dataanalysis/opusview/index'),
                        name: 'opusview',
                        meta: {},
                        hidden: true,
                    },
                    {
                        path: '/dataanalysis/comicview',
                        name: 'comicview',
                        component: () => import('@/views/dataanalysis/opusview/index'),
                        // meta: { title: '', cache: true},
                        hidden: true,
                    },
                    {
                        path: '/dataanalysis/comicfansportrait',
                        name: 'comicfansportrait',
                        component: () => import('@/views/dataanalysis/opusview/index'),
                        // meta: { title: '', cache: true},
                        hidden: true,
                    },
                    {
                        path: '/dataanalysis/interactionanalysis',
                        name: 'interactionanalysis',
                        component: () => import('@/views/dataanalysis/opusview/index'),
                        // meta: { title: '', cache: true},
                        hidden: true,
                    },
                ],
            },
            {
                path: 'postview',
                name: 'postView',
                component: () => import('@/views/dataanalysis/postview/index'),
                meta: { title: '帖子数据', role: 'social_creator_center_privilege', cache: false },
                hidden: false,
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        name: 'rewardfans',
        meta: { icon: 'icon_topic_exposure' },
        children: [
            {
                path: 'rewardfans',
                name: 'rewardFansIndex',
                component: () => import('@/views/rewardfans/index'),
                meta: { title: '加料粉丝', role: 'reward_fans', cache: false },
                hidden: false,
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        name: 'secret',
        meta: {},
        hidden: true,
        children: [
            {
                path: 'secret/:type',
                name: 'secretDetailIndex',
                component: () => import('@/views/secret/index'),
                meta: { title: '协议', cache: false },
                hidden: true,
            },
        ],
    },
    // {
    // 	path: '',
    // 	component: Layout,
    // 	redirect: 'noredirect',
    // 	name: 'feed',
    // 	meta: { icon: 'icon_nav_feed' },
    // 	hidden: true,
    // 	children: [{
    // 		path: 'feed',
    // 		component: () => import('@/views/feed/index'),
    // 		name: 'feedIndex',
    // 		meta: { title: '发布动态', role: 'pub_feed' }
    // 	}]
    // },
    // {
    // 	path: '',
    // 	component: Layout,
    // 	redirect: 'noredirect',
    // 	name: 'live',
    // 	meta: { icon: 'icon_nav_live' },
    // 	children: [{
    // 		path: 'live',
    // 		component: () => import('@/views/live/index'),
    // 		name: 'liveIndex',
    // 		meta: { title: '发布直播', role: 'pub_live' }
    // 	}]
    // },
    {
        path: '/invitation',
        component: Layout,
        redirect: 'noredirect',
        name: 'invitation',
        meta: { title: '发布帖子', icon: 'icon_nav_invitation', open: true },
        children: [
            {
                path: 'article',
                name: 'postArticle',
                component: () => import('@/views/post/postArticle'),
                meta: { title: '文章' },
            },
            {
                path: 'history',
                name: 'postHistory',
                component: () => import('@/views/post/history'),
                hidden: true,
            },
            {
                path: 'publish',
                name: 'postPublish',
                component: () => import('@/views/post/Publish'),
                hidden: true,
            },
            {
                path: 'time',
                name: 'timePublish',
                component: () => import('@/views/post/TimePublish'),
                hidden: true,
            },
            {
                path: 'video',
                name: 'postVideo',
                component: () => import('@/views/postVideo/Upload'),
                meta: { title: '视频' },
            },
            {
                path: 'video_list',
                name: 'postVideoList',
                component: () => import('@/views/postVideo/List'),
                hidden: true,
            },
            {
                path: 'story',
                name: 'invitationStory',
                component: () => import('@/views/blank/index'),
                meta: {
                    title: '对话小说',
                    role: 'social_pub_chat_story',
                    externalLink: '/game/chat-story/pc-edit/',
                },
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        name: 'demos',
        meta: { icon: 'list' },
        hidden: true,
        children: [
            {
                path: 'demos',
                component: () => import('@/views/demos/index'),
                name: 'demoComponents',
                meta: { title: '组件demo' },
            },
        ],
    },
    {
        path: '/comic_video',
        component: Layout,
        redirect: 'noredirect',
        name: 'comicVideo',
        meta: { title: '漫剧管理', role: 'social_comic_video', icon: 'icon_nav_live' },
        hidden: false,
        children: [
            {
                path: 'list',
                component: () => import('@/views/comicVideo/comicVideoList'),
                name: 'comicVideoList',
                meta: { title: '漫剧管理' },
            },
            {
                path: 'detail',
                component: () => import('@/views/comicVideo/comicVideoDetail'),
                name: 'comicVideoDetail',
                meta: { title: '剧集管理' },
                hidden: true,
            },
            {
                path: 'post',
                component: () => import('@/views/comicVideo/comicVideoPost'),
                name: 'comicVideoPost',
                meta: { title: '添加剧集' },
                hidden: true,
            },
            {
                path: 'publish',
                component: () => import('@/views/comicVideo/comicVideoPublish'),
                name: 'comicVideoPublish',
                meta: { title: '剧集发布', cache: true },
                hidden: true,
            },
            {
                path: 'compilations_edit',
                component: () => import('@/views/comicVideo/comicVideoCometitionsEdit'),
                name: 'comicVideoCometitionEdit',
                hidden: true,
            },
            {
                path: 'compilations_publish',
                component: () => import('@/views/comicVideo/comicVideoCometitionsPublish'),
                name: 'comicVideoCometitionsPublish',
                hidden: true,
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        name: 'compilations',
        meta: { title: '合集管理', icon: 'icon_nav_invitation', open: true },
        hidden: false,
        children: [
            {
                path: 'compilations',
                component: () => import('@/views/compilations/compilationsList'),
                name: 'compilationsList',
                meta: { title: '合集管理', cache: true },
            },
            {
                path: 'compilations_post',
                component: () => import('@/views/compilations/compilationsPostList'),
                name: 'compilationsPostList',
                meta: { title: '合集详情', cache: true },
                hidden: true,
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        name: 'kkschool',
        meta: { title: 'KK学院', icon: 'icon_kkschool' },
        hidden: false,
        children: [
            {
                path: 'kkschool',
                component: () => import('@/views/kkschool/index'),
                name: 'kkschoolIndex',
                meta: { title: 'KK学院', cache: true, tips: '更新啦' },
            },
            {
                path: 'kkschool/lesson_detail/:id',
                component: () => import('@/views/kkschool/detail'),
                name: 'kkschoolDetail',
                hidden: true,
                meta: { title: '课程详情' },
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        name: 'activity',
        meta: { title: '创作活动', icon: 'activity' },
        hidden: false,
        children: [
            {
                path: 'activity',
                component: () => import('@/views/activity/index'),
                name: 'activityIndex',
                meta: { title: '创作活动' },
            },
            {
                path: 'activity/activity_detail/:id',
                component: () => import('@/views/activity/detail'),
                name: 'activityDetail',
                hidden: true,
                meta: { title: '活动详情' },
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        name: 'setaccount',
        meta: { title: '账号设置', icon: 'el-icon-user' },
        hidden: false,
        children: [
            {
                path: 'accountdetail',
                component: () => import('@/views/accountinfo/index'),
                name: 'accountInfo',
                meta: { title: '账号设置' },
            },
            {
                path: 'basicinfo',
                component: () => import('@/views/accountinfo/setbasicinfo'),
                name: 'basicinfo',
                hidden: true,
                meta: { title: '编辑联系方式' },
            },
            {
                path: 'identinfo',
                component: () => import('@/views/accountinfo/setidentinfo'),
                name: 'identinfo',
                hidden: true,
                meta: { title: '编辑认证信息' },
            },
        ],
    },
    {
        path: '/prononcement',
        component: Layout,
        redirect: 'noredirect',
        hidden: true,
        children: [
            {
                path: 'list',
                component: () => import('@/views/article/list'),
                name: 'prononceArticle',
                meta: { title: '公告', pointTo: '/homepage' },
            },
            {
                path: ':id',
                component: () => import('@/views/article/index'),
                name: 'prononceArticle',
                meta: { title: '公告', pointTo: '/homepage' },
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        hidden: true,
        children: [
            {
                path: '/message/:type',
                component: () => import('@/views/message/messageIndex'),
                name: 'messageList',
                meta: { title: '通知中心', pointTo: '/homepage' },
                // children: [{
                // 	path: '/message/detail/:id',
                // 	component: () => import('@/views/article/index'),
                // 	name: 'messageArticle',
                // 	meta: { title: '通知详情', pointTo: '/homepage' }
                // }]
            },
            {
                path: '/message/detail/:id',
                component: () => import('@/views/article/index'),
                name: 'messageArticle',
                meta: { title: '通知详情', pointTo: '/homepage' },
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        hidden: true,
        children: [
            {
                path: '/scriptwriting/',
                component: () => import('@/views/scriptwriting/index'),
                name: 'scriptwriting',
                meta: { title: '上传漫画剧本', pointTo: '/homepage' },
            },
        ],
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        children: [
            {
                path: '/faq',
                component: () => import('@/views/homepage/faq.vue'),
                name: 'faq',
            },
        ],
        hidden: true,
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        children: [
            {
                path: '/roadmap',
                component: () => import('@/views/roadmap/index.vue'),
                name: 'roadmap',
                meta: { title: '漫画晋级路', pointTo: '/homepage' },
            },
        ],
        hidden: true,
    },
    {
        path: '',
        component: Layout,
        redirect: 'noredirect',
        children: [
            {
                path: '/competition',
                component: () => import('@/views/competition/index.vue'),
                name: 'competition',
                meta: { title: '条漫大赛', pointTo: '/homepage' },
            },
            {
                path: '/competition/detail/:id',
                component: () => import('@/views/competition/detail.vue'),
                name: 'competitionNews',
                meta: { title: '资讯详情', pointTo: '/homepage' },
            },
        ],
        hidden: true,
    },
    { path: '/login', name: 'login', component: () => import('@/views/login/index'), hidden: true },
    {
        path: '/applyauthor',
        name: 'applyauthor',
        component: () => import('@/views/user/apply'),
        hidden: true,
    },
    { path: '/404', component: () => import('@/views/error/404'), hidden: true },
    { path: '*', redirect: '/404', hidden: true },
];

export default new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap,
});
